import HeroSection from "./HomePages/HeroSection";
import AboutSection from "./HomePages/AboutSection";
import ServicesSection from "./HomePages/ServicesSection";
import SectorSection from "./HomePages/SectorSection";
import ContactSection from "./HomePages/ContactSection";
import BlogSection from "./HomePages/BlogSection";
import FeedbackSection from "./HomePages/FeedbackSection";
import ChooseUsSection from "./HomePages/ChooseUsSection";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  useEffect(() => {
    AOS.init({
      disable: function () {
        var maxWidth = 700;
        return window.innerWidth < maxWidth;
      },
      once: true,
    });
  }, []);

  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ChooseUsSection />
      <SectorSection />
      <ContactSection />
      <FeedbackSection />
      <BlogSection />
    </>
  );
};

export default Home;
